import { defineMessages } from 'react-intl';

export default defineMessages({
  buttonTitle: { defaultMessage: 'Ok, I got it' },
});
